import { action } from 'satcheljs/lib/legacy';
import type * as Schema from 'owa-graph-schema';
import { getLeftNavGroupFoldersStore } from 'owa-group-left-nav-folders-store';
import type { GroupFolder } from 'owa-groups-services/lib/groups-rest-apis/schema/GroupFolder';

export let updateGroupFolderHierarchy = action('updateGroupFolderHierarchy')(function (
    groupSmtpAddress: string,
    folder: Schema.GroupFolder
): void {
    const newGroupFolder = createFolder(folder);

    const folderHierarchy = getLeftNavGroupFoldersStore().folderTable.get(
        groupSmtpAddress.toLowerCase()
    )?.folderHierarchy;
    const parentFolderId = newGroupFolder.ParentFolderId;

    if (folderHierarchy) {
        // If the folder is already present in store - return
        if (folderHierarchy.has(newGroupFolder.Id)) {
            return;
        }
        // Update child folders of current folder
        for (const groupFolder of folderHierarchy.values()) {
            if (groupFolder.ParentFolderId === newGroupFolder.Id) {
                newGroupFolder.ChildFolderIds.push(groupFolder.Id);
            }
        }

        // add folder to hierarchy
        folderHierarchy.set(folder.FolderId, newGroupFolder);

        // add current folder to ChildFolderIds of parent folder.
        if (folderHierarchy.has(parentFolderId)) {
            const groupFolder = folderHierarchy.get(parentFolderId);
            if (groupFolder) {
                groupFolder.ChildFolderIds.push(newGroupFolder.Id);
            }
        }
    }
});

function createFolder(folder: Schema.GroupFolder): GroupFolder {
    return {
        __type: 'GroupFolder',
        OdataId: folder.OdataId,
        Id: folder.FolderId,
        ParentFolderId: folder.ParentFolderId,
        DisplayName: folder.DisplayName,
        UnreadItemCount: folder.UnreadItemCount,
        TotalItemCount: folder.TotalItemCount,
        ChildFolderCount: folder.ChildFolderCount,
        WellKnownName: folder.WellKnownName,
        IsHidden: folder.IsHidden,
        SizeInBytes: parseInt(folder.SizeInBytes),
        ChildFolderIds: [],
    } as GroupFolder;
}
